<!--
 * @Author: gjc
 * @Date: 2022-03-22 11:51:35
 * @LastEditors: gjc
 * @LastEditTime: 2022-03-25 14:08:51
 * @Description: 产业政策（天津市）
-->
<template>
  <div class="industry_policy">
    <a-spin class="spin" tip="加载中" size="large" :spinning="loading" />

    <div class="header">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="产业政策" key="industryPolicyTab"></a-tab-pane>
      </a-tabs>

      <div class="filter_item">
        <span class="txt">政策主题：</span>
        <div class="item_box" :class="{'showMore': isShowMore.themes}">
          <span
            style="margin-left: 10px"
            class="option_item"
            @click="changeThemes({ code: '', name: '全部' })"
            :class="{ 'active': selectedThemes.length == 0 }"
            >全部</span
          >
          <span
            class="option_item"
            @click="changeThemes(item)"
            :class="{ 'active': selectedThemes.indexOf(item.code) > -1 }"
            v-for="(item, index) in themesList"
            :key="index + 'themes'"
            >{{ item.name }}</span
          >
        </div>
        <span
          class="more"
          :class="{ 'flag': isShowMore.themes }"
          @click="getMore(1)"
          >{{ isShowMore.themes ? '收起' : '更多' }}</span
        >
      </div>
      <div class="filter_item">
        <span class="txt">项目类别：</span>
        <div class="item_box" :class="{'showMore': isShowMore.projectCat}">
          <span
            style="margin-left: 10px"
            class="option_item"
            @click="changeProjectCat({ code: '', name: '全部' })"
            :class="{ 'active': selectedItemCategory.length == 0 }"
            >全部</span
          >
          <span
            class="option_item"
            @click="changeProjectCat(item)"
            :class="{ 'active': selectedItemCategory.indexOf(item.name) > -1 }"
            v-for="(item, index) in projectCatList"
            :key="index + 'projectCat'"
            >{{ item.name }}</span
          >
        </div>
        <span
          class="more"
          :class="{ 'flag': isShowMore.projectCat }"
          @click="getMore(2)"
          >{{ isShowMore.projectCat ? '收起' : '更多' }}</span
        >
      </div>
      <div class="filter_item">
        <span class="txt">产业类别：</span>
        <div class="item_box" :class="{'showMore': isShowMore.industryCat}">
          <span
            style="margin-left: 10px"
            class="option_item"
            @click="changeIndustryCat({ value: '', name: '全部' })"
            :class="{ 'active': selectedIndustryCategory.length == 0 }"
            >全部</span
          >
          <span
            class="option_item"
            @click="changeIndustryCat(item)"
            :class="{ 'active': selectedIndustryCategory.indexOf(item.name) > -1 }"
            v-for="(item, index) in industryCatList"
            :key="index + 'industryCat'"
            >{{ item.name }}</span
          >
        </div>
        <span
          class="more"
          :class="{ 'flag': isShowMore.industryCat }"
          @click="getMore(3)"
          >{{ isShowMore.industryCat ? '收起' : '更多' }}</span
        >
      </div>
      <div class="filter_item">
        <span class="txt">发布机构：</span>
        <div class="item_box" :class="{'showMore': isShowMore.publishDept}">
          <span
            style="margin-left: 10px"
            class="option_item"
            @click="changePublishDept({ code: '', name: '全部' })"
            :class="{ 'active': selectedPublishDepartment == '' }"
            >全部</span
          >
          <span
            class="option_item"
            @click="changePublishDept(item)"
            :class="{ 'active': selectedPublishDepartment == item.code }"
            v-for="(item, index) in publishDeptList"
            :key="index + 'publishDept'"
            >{{ item.name }}</span
          >
        </div>
        <span
          class="more"
          :class="{ 'flag': isShowMore.publishDept }"
          @click="getMore(4)"
          >{{ isShowMore.publishDept ? '收起' : '更多' }}</span
        >
      </div>
      <div class="filter_item">
        <span class="txt" style="line-height:31px;">关键词：</span>
        <input
          type="text"
          class="search"
          v-model="queryParams.keyword"
          @keyup.enter="getList"
          placeholder="请输入政策关键词，如高新技术企业"
        />
        <svg-icon icon-class="search1" class="search_icon" @click.native="getList"/>
      </div>
    </div>

    <div class="line"></div>

    <div class="content_box">
      <div class="records">
        <p>共为您检索到<span>{{ total }}</span>条记录</p>
        <!-- <a-select
          style="margin-bottom: 10px; width: 130px"
          v-model="queryParams.days"
          @change="getList"
        >
          <a-select-option :value="0">全部时间</a-select-option>
          <a-select-option :value="7"> 最近7天内截止 </a-select-option>
          <a-select-option :value="30"> 最近30天内截止 </a-select-option>
        </a-select> -->
      </div>

      <template>
        <a-table
          row-key="id"
          :columns="columnsData"
          :data-source="tableData"
          :pagination="{
            pageSize: paginationConfig.pageSize,
            current: paginationConfig.pageNum,
            total: total,
            showQuickJumper: true, //显示跳转页数
            showSizeChanger: true, // 显示可改变每页数量
            pageSizeOptions: ['10', '20'], // 每页数量选项
            showTotal: (total) => `共 ${total} 条`, //显示总数
          }"
          @change="onTableChange"
        >
          <div class="policy_name" slot="policyName" slot-scope="record">
            <a :title="record.title" @click.prevent="goToDetail(record.id)">
              {{ record.title }}
            </a>
          </div>
          <div slot="fbDate" slot-scope="record">
            <span>{{ record.fbDate.split(' ')[0] }}</span>
          </div>
        </a-table>
      </template>
    </div>
  </div>
</template>

<script>
import { getPolicyESList, getItemCategoryList, getIndustryCategoryList, getPolicyESDepts, getPolicyESThemes } from '@/api/industryPolicy';
export default {
  name: 'industryPolicy',
  data() {
    return {
      activeName: 'industryPolicyTab',

      //表格相关
      loading: false,
      tableData: [],
      columnsData: [
        {
          title: '政策名称',
          scopedSlots: { customRender: 'policyName' },
          width: '35%',
          ellipsis: true,
        },
        {
          title: '发布机构',
          dataIndex: 'dept',
          width: '25%',
          ellipsis: true,
        },
        {
          title: '发文字号',
          dataIndex: 'fwzh',
          width: '25%',
          ellipsis: true,
        },
        {
          title: '发文日期',
          scopedSlots: { customRender: 'fbDate' },
          width: '15%',
          ellipsis: true,
        },
      ],

      //分页相关
      total: 0,
      paginationConfig: {
        pageNum: 1,
        pageSize: 10,
      },

      queryParams: {
        partition: [], //项目类别
        industry: [], //产业类别
        theme: [], //主题
        dept: '', //发布机构
        keyword: '', //关键词

        // days: 0,
      },

      //筛选条件更多展示
      isShowMore: {
        themes: false,
        projectCat: false,
        industryCat: false,
        publishDept: false,
      },
      //政策主题
      themesList: [],
      selectedThemes: [],
      //项目类别
      projectCatList: [],
      selectedItemCategory: [],
      //产业类别
      industryCatList: [],
      selectedIndustryCategory: [],
      //受理部门
      publishDeptList: [],
      selectedPublishDepartment: '',
    };
  },
  created() {
    this.init();
  },
  methods: {
    goToDetail(id){
      this.$router.push({
        path: '/industryDetail',
        query: {
          targetId: id,
        }
      })
    },
    //页面初始化
    init() {
      this.getPolicyESThemesPro()
      this.listItemCategoryPro()
      this.listIndustryCategoryPro()
      this.getPolicyESDeptsPro()
      this.getPolicyESListPro()
    },
    //重置列表
    getList() {
      this.paginationConfig.pageNum = 1;
      this.getPolicyESListPro();
    },
    //表格分页改变
    onTableChange({ current, pageSize }) {
      this.paginationConfig.pageSize = pageSize;
      this.paginationConfig.pageNum = current;
      this.getPolicyESListPro();
    },

    //更多筛选条件
    getMore(type) {
      switch(type){
        case 1: this.isShowMore.themes = !this.isShowMore.themes;break;
        case 2: this.isShowMore.projectCat = !this.isShowMore.projectCat;break;
        case 3: this.isShowMore.industryCat = !this.isShowMore.industryCat;break;
        case 4: this.isShowMore.publishDept = !this.isShowMore.publishDept;break;
        default: return;
      }
    },

    //改变筛选条件
    changeThemes(item) {
      //已经选中全部，再选其他的选项，取消全部的选中状态
      if (item.code != '' && this.selectedThemes.length == 0) {
        this.selectedThemes = [];
        this.selectedThemes.push(item.code);
        this.getList();
        return;
      }
      //判断是选中还是取消选中
      if (this.selectedThemes.indexOf(item.code) > -1) {
        //取消
        if (item.code == '') {
          //点击全部，取消其他项的选中状态
          this.selectedThemes = [];
        } else {
          //取消选中
          this.selectedThemes.splice(
            this.selectedThemes.indexOf(item.code),
            1
          );
        }
      } else {
        //选中
        if (item.code == '') {
          //选中全部，其他选项取消选中状态
          this.selectedThemes = [];
        } else {
          //选中其他项
          this.selectedThemes.push(item.code);
        }
      }
      this.getList();
    },
    changeProjectCat(item) {
      //已经选中全部，再选其他的选项，取消全部的选中状态
      if (item.code != '' && this.selectedItemCategory.length == 0) {
        this.selectedItemCategory = [];
        this.selectedItemCategory.push(item.name);
        this.getList();
        return;
      }
      //判断是选中还是取消选中
      if (this.selectedItemCategory.indexOf(item.name) > -1) {
        //取消
        if (item.code == '') {
          //点击全部，取消其他项的选中状态
          this.selectedItemCategory = [];
        } else {
          //取消选中
          this.selectedItemCategory.splice(
            this.selectedItemCategory.indexOf(item.name),
            1
          );
        }
      } else {
        //选中
        if (item.code == '') {
          //选中全部，其他选项取消选中状态
          this.selectedItemCategory = [];
        } else {
          //选中其他项
          this.selectedItemCategory.push(item.name);
        }
      }
      this.getList();
    },
    changeIndustryCat(item) {
      //已经选中全部，再选其他的选项，取消全部的选中状态
      if (item.value != '' && this.selectedIndustryCategory.length == 0) {
        this.selectedIndustryCategory = [];
        this.selectedIndustryCategory.push(item.name);
        this.getList();
        return;
      }
      //判断是选中还是取消选中
      if (this.selectedIndustryCategory.indexOf(item.name) > -1) {
        //取消
        if (item.value == '') {
          //点击全部，取消其他项的选中状态
          this.selectedIndustryCategory = [];
        } else {
          //取消选中
          this.selectedIndustryCategory.splice(
            this.selectedIndustryCategory.indexOf(item.name),
            1
          );
        }
      } else {
        //选中
        if (item.value == '') {
          //选中全部，其他选项取消选中状态
          this.selectedIndustryCategory = [];
        } else {
          //选中其他项
          this.selectedIndustryCategory.push(item.name);
        }
      }
      this.getList();
    },
    changePublishDept(item) {
      this.selectedPublishDepartment = item.code;
      this.queryParams.dept = item.code;
      this.getList();
    },

    //政策主题
    async getPolicyESThemesPro(){
      const { code, data } = await getPolicyESThemes()
      if(code == 0){
        this.themesList = data || []
      }
    },
    //项目类别
    async listItemCategoryPro(){
      const { code, data } = await getItemCategoryList()
      if(code == 0){
        this.projectCatList = data || []
      }
    },
    //产业类别
    async listIndustryCategoryPro(){
      const { code, data } = await getIndustryCategoryList()
      if(code == 0){
        this.industryCatList = data || []
      }
    },
    //发布机构
    async getPolicyESDeptsPro(){
      const { code, data } = await getPolicyESDepts()
      if(code == 0){
        this.publishDeptList = data || []
      }
    },

    //es政策列表
    async getPolicyESListPro(){
      // 政策主题传参处理
      if (this.selectedThemes.length == 0) {
        this.queryParams.theme = [];
      } else {
        this.queryParams.theme = [...this.selectedThemes];
      }
      // 项目类别传参处理
      if (this.selectedItemCategory.length == 0) {
        this.queryParams.partition = [];
      } else {
        this.queryParams.partition = [...this.selectedItemCategory];
      }
      // 产业类别传参处理
      if (this.selectedIndustryCategory.length == 0) {
        this.queryParams.industry = [];
      } else {
        this.queryParams.industry = [...this.selectedIndustryCategory];
      }

      /* if (this.queryParams.days == 0) {
        this.queryParams.days = null;
      } */

      this.loading = true;
      const { code, data } = await getPolicyESList({
        ...this.queryParams,
        ...this.paginationConfig
      })
      if(code == 0){
        this.tableData = data.list || []
        this.total = data.total

        /* if (this.queryParams.days == null) {
          this.queryParams.days = 0;
        } */
        this.loading = false;
      }else{
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.industry_policy{
  height: 100%;
  background: #fff;
  position: relative;

  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }

  .header {
    background-color: #fff;
    padding: 20px;

    ::v-deep .ant-tabs-tab-active {
      font-weight: 500;
      color: #333;
      font-size: 16px;
      padding: 12px 0;
    }

    ::v-deep .ant-tabs-tab {
      padding-top: 0;
    }

    ::v-deep .ant-tabs-ink-bar {
      width: 64px;
    }

    .filter_item {
      display: flex;
      margin-bottom: 5px;
      .txt {
        padding: 0;
      }
      .item_box {
        flex: 1;
        overflow: hidden;
        height: 40px;
        transition: all 2s;

        span {
          display: inline-block;
        }
      }

      .showMore {
        height: auto;
      }

      ::v-deep .ant-btn {
        padding: 0;
      }

      ::v-deep .ant-btn {
        span {
          color: #0072f7;
        }
      }

      .search {
        width: 300px;
        height: 32px;
        padding-left: 10px;
        padding-right: 28px;
        margin-left: 24px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #e0e0e0;
        font-size: 14px;
        font-weight: 400;
        outline: none;
      }

      .search::-webkit-input-placeholder {
        color: #dddddd;
      }

      .search::-ms-input-placeholder {
        color: #dddddd;
      }

      .search::-moz-placeholder {
        color: #dddddd;
      }

      .search_icon {
        width: 14px;
        height: 14px;
        margin-top: 9px;
        margin-left: -28px;
        color: #0072f7;
        cursor: pointer;
      }

      span {
        // display: inline-block;
        font-size: 14px;
        font-weight: 400;
        padding: 0px 10px;
        max-height: 31px;
      }

      .option_item {
        height: 24px;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0px 10px;
        // padding-bottom: 15px;
        cursor: pointer;
        display: block;
        //float: left;
      }

      .more {
        float: right;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        cursor: pointer;
      }

      .flag::after {
        transform: rotate(-135deg) !important;
        vertical-align: -1px !important;
      }

      .more::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 7px;
        margin-left: 5px;
        transform: rotate(45deg);
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        vertical-align: 2px;
      }

      .active {
        height: 24px;
        line-height: 24px;
        background: #0072f7;
        border-radius: 4px;
        color: #fff;
      }
    }
  }

  .line {
    height: 10px;
    background: #eff2f5;
  }

  .content_box {
    padding: 20px;
    padding-bottom: 0;
    background: #fff;

    ::v-deep .ant-table-thead {
      th {
        padding: 9px 16px !important;
      }
    }
    ::v-deep .ant-table-tbody {
      td {
        padding: 9px 16px !important;
        div.policy_name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          a{
            text-decoration:none;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
    }

    .records {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #666;

        span {
          color: #ff4e00;
        }
      }

      ::v-deep .ant-select-dropdown-menu-item-selected {
        background-color: #e6f7ff;
      }
    }
  }
}
</style>
